import { useMemo } from "react";

const APP_STATUS = [
  {
    name: "submitted",
    label: "Submitted",
  },
  {
    name: "authorized",
    label: "Authorized",
  },
  {
    name: "docs_received",
    label: "Documents Received",
  },
  {
    name: "processing",
    label: "Processing",
  },
  {
    name: "done",
    label: "Done",
  },
];

const ApplicationStatusBar = ({
  status = "submitted",
  variant = "primary",
}) => {
  const idx = useMemo(
    () => APP_STATUS.findIndex((item, x) => item.name === status),
    [status]
  );

  return (
    <div className="application-status-bar row mb-3">
      <div className="btn-group" role="group">
        {APP_STATUS.map((status, x) => (
          <label
            key={status.name}
            className={`btn btn-outline-${variant} text-muted fw-normal bg-white border-light  
            } ${x <= idx ? `active fw-semibold` : ""}`}
          >
            {status.label}
            {x <= idx && <i className="bi bi-check-lg ms-1  fs-16" />}
          </label>
        ))}
      </div>
    </div>
  );
};

ApplicationStatusBar.propTypes = {};

export default ApplicationStatusBar;
